// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rQmb","title":"styles_title__3zwNN"};